import User from "../../../apis/User";
import Clients from "../../../apis/Clients";
import router from "../../../router";

const state = {
    clients: [],
    clientError: ""
};

const getters = {
    getClients: () => state.clients.map(el => (
        {
            id: el.id,
            client_uid: el.client_uid,
            name: el.name,
            is_active: el.is_active,
            users: el.users,
            cluster: el.cluster
        }
    ))
};

const actions = {
    getAllClients({ commit }) {
        return new Promise((resolve, reject) => {
            Clients.index()
                .then((response) => {
                    resolve(response.data.data[0]);
                    commit("GET_ALL_CLIENTS", response.data.data[0])
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("GET_ALL_CLIENTS", []);
                        commit("DETECT_CLIENT_ERROR", error.response);
                    }
                })
        });
    },
    getClient({ commit }, id) {
        return new Promise((resolve, reject) => {
            Clients.show(id)
                .then((response) => {
                    resolve(response.data);

                    commit("GET_CLIENT")
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("GET_ALL_CLIENTS", []);
                        commit("DETECT_CLIENT_ERROR", error.response);
                    }
                })
        })
    },
    addUserToClient({ commit }, obj) {
        commit("ADD_USER_TO_CLIENT", obj);
    },
    updateClient({ commit }, { id, obj }) {
        return new Promise((resolve, reject) => {
            Clients.update(id, obj)
                .then((response) => {
                    resolve(response.data);

                    commit("UPDATE_CLIENT", response.data);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_CLIENT_ERROR", error.response);
                    }
                })
        })
    },
};

const mutations = {
    GET_ALL_CLIENTS(state, response) {
        state.clients = response;
    },
    GET_CLIENT(state, id) {
    },
    ADD_USER_TO_CLIENT(state, obj) {
        const client = state.clients.find(el => el.client_uid === obj.client_uid);
        client.users.push(obj);
    },
    UPDATE_ClIENT(state, obj) {
        let objIndexToUpdate = state.clients.findIndex(el => el.id === obj.id);
        state.clients[objIndexToUpdate] = obj;
    },
    DETECT_CLIENT_ERROR(state, error) {
        setTimeout(() => {
            state.clientError = "";
        }, 1000)

        if (error.status == 401 || error.status == 419) {
            User.logout()
                .then(() => {
                    localStorage.removeItem("auth");
                    router.push({ name: "Login", path: router.currentRoute.path });
                })
        } else if (error.data.message !== undefined) {
            state.clientError = error.data.message;
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}